import { $a } from 'shared-base';
import { bridge } from '../../globals';
import { Json } from '../../types';
import { Button } from '../Button/Button';
import Parameters from '../Parameters/Parameters';
import { Bottom, Content, Wrapper } from './NavBarObject.style';

export type NavBarObjectProps = {
  data: {
    parametersWithValues: Json;
  };
  callbacks: {
    onNavigate: (path: string) => void;
    onAction: OnAction;
  };
};

export function NavBarObject(props: NavBarObjectProps) {
  const { data, callbacks } = props;
  const { parametersWithValues } = data;

  function onParameterSet(id: string, value: string | number | boolean) {
    callbacks.onAction($a('VALUES', 'patch', '', { [id]: value }));
  }

  function onChangeSliders(id: string, value: string | number | boolean, isSilent?: boolean) {
    const change = { [id]: value };
    bridge.patchValuesModel('main', change);
  }

  function onResetValues() {
    callbacks.onAction($a('VALUES', 'reset'));
  }

  return (
    <Wrapper className='NavBarObject-wrapper' data-testid='NavBarObject-wrapper'>
      <Content>
        <Parameters
          id={'object'}
          onChange={onChangeSliders}
          onSet={onParameterSet}
          data={parametersWithValues}
        />
      </Content>
      <Bottom>
        <Button onClick={onResetValues} color='pink' variant='subtle'>
          Reset to Default
        </Button>
      </Bottom>
    </Wrapper>
  );
}

export default NavBarObject;
